import React from 'react'
import { Breadcrumb, Button } from '../../../components/ui'
import Icon from '../../../components/Icon'
import {
  getDepartmentInitials,
  getDepartmentSubtitle,
} from './departmentDetailUtils'

function DepartmentDetailHeader ({
  department,
  teamsCount,
  canEdit,
  isEditMode,
  onCloseEdit,
  onEdit,
  onDelete,
}) {
  return (
    <header className="department-detail-header">
      <Breadcrumb
        className="department-detail-breadcrumb"
        items={[
          { label: 'Главная', to: '/company' },
          { label: 'Подразделения', to: '/company/departments' },
          { label: department?.name || 'Подразделение' },
        ]}
      />

      <div className="department-detail-titlebar">
        <div className="department-detail-titlebar-main">
          <div className="department-detail-mark" aria-hidden>
            {getDepartmentInitials(department?.name)}
          </div>
          <div className="department-detail-titlecopy">
            <h1 className="ds-page-title">{department?.name || 'Подразделение'}</h1>
            <p className="department-detail-subtitle">
              {getDepartmentSubtitle(department, teamsCount)}
            </p>
          </div>
        </div>

        <div className="department-detail-actions">
          {canEdit && (
            isEditMode ? (
              <>
                <Button variant="ghost" onClick={onCloseEdit} className="btn-back">
                  <Icon name="chevronLeft" size={18} aria-hidden /> К просмотру
                </Button>
                <Button
                  type="button"
                  variant="danger"
                  onClick={onDelete}
                  aria-label="Удалить подразделение"
                >
                  Удалить
                </Button>
                <Button type="submit" form="department-edit-form" variant="primary">
                  Сохранить
                </Button>
              </>
            ) : (
              <Button type="button" variant="primary" onClick={onEdit}>
                <Icon name="edit" size={16} aria-hidden /> Редактировать
              </Button>
            )
          )}
        </div>
      </div>
    </header>
  )
}

export default DepartmentDetailHeader
